import type { SelectOption } from '@/types'

import { isValidEmail, isValidMobile } from '@/lib/validation'

import {
    centerOptions,
    passingYearOptions,
    programOptions,
    qualificationOptions
} from '@/constants/content'

export type RegistrationField =
    | 'fullName'
    | 'mobile'
    | 'email'
    | 'qualification'
    | 'passingYear'
    | 'college'
    | 'center'
    | 'program'
    | 'message'

export type RegistrationInput = Record<RegistrationField, string>

export type RegistrationErrors = Partial<Record<RegistrationField, string>>

export const REGISTRATION_FIELDS: Array<RegistrationField> = [
    'fullName',
    'mobile',
    'email',
    'qualification',
    'passingYear',
    'college',
    'center',
    'program',
    'message'
]

export const emptyRegistration: RegistrationInput = {
    fullName: '',
    mobile: '',
    email: '',
    qualification: '',
    passingYear: '',
    college: '',
    center: '',
    program: '',
    message: ''
}

const hasOption = (options: Array<SelectOption>, value: string): boolean => options.some((option) => option.value === value)

export const optionLabel = (options: Array<SelectOption>, value: string): string => options.find((option) => option.value === value)?.label ?? value

export const validateRegistration = (input: RegistrationInput): RegistrationErrors => {
    const errors: RegistrationErrors = {}
    const fullName = input.fullName.trim()
    const email = input.email.trim()

    if (fullName.length < 2) errors.fullName = "Enter your full name."
    else if (fullName.length > 80) errors.fullName = "Keep your name under 80 characters."

    if (!isValidMobile(input.mobile)) errors.mobile = input.mobile.trim() ? "Enter a valid 10-digit mobile number." : "Enter your mobile number."

    if (email && (email.length > 120 || !isValidEmail(email))) errors.email = "Enter a valid email address, or leave it empty."

    if (!hasOption(qualificationOptions, input.qualification)) errors.qualification = "Choose your qualification."

    if (!hasOption(passingYearOptions, input.passingYear)) errors.passingYear = "Choose your year of passing."

    if (input.college.trim().length > 120) errors.college = "Keep this under 120 characters."

    if (!hasOption(centerOptions, input.center)) errors.center = "Choose a training center."

    if (!hasOption(programOptions, input.program)) errors.program = "Choose a program."

    if (input.message.trim().length > 1000) errors.message = "Keep your note under 1,000 characters."

    return errors
}
